import * as React from 'react';
import styles from './SellerCheckoutModal.styl';
import Divider from '../../ui/Divider/Divider';
const SellerCheckoutModal = ({ content, icon, t }) => {
    return (React.createElement("div", { className: styles.modalWrapper },
        React.createElement("span", { className: styles.imprintText }, content?.imprint?.text?.de),
        React.createElement(Divider, null),
        React.createElement("span", { className: styles.secondTitle }, t('CheckoutPage:modals.sellerImprint.secondTitle')),
        React.createElement(Divider, null),
        React.createElement("span", { className: `${styles.imprintText} ${styles.termCond}` }, content?.termCond?.text?.de)));
};
export default SellerCheckoutModal;
